import { styled } from "@mui/material/styles";
import { C8ThreeDMesh } from "csi/state/3D/canvasStore";
import { useStore } from "csi/state/hooks";
import CheckboxTree from "designSystem/components/checkbox/CheckboxTree";
import { Box, FlexColumn, PaneHeader } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";

const PREFIX = "ThreeDModelComponents";

const classes = {
	containerClass: `${PREFIX}containerClass`,
	fullWidth: `${PREFIX}fullWidth`,
	nested: `${PREFIX}nested`,
};

const StyledFlexColumn = styled(FlexColumn)((
	{
		theme,
	},
) => ({
	[`& .${classes.containerClass}`]: {
		overflowX: "hidden",
		overflowY: "scroll",
	},

	[`& .${classes.fullWidth}`]: {
		width: "100%",
	},

	[`& .${classes.nested}`]: {
		padding: theme.spacing(2),
		paddingLeft: 50,
	},
}));

export interface MeshCheckboxProps {
	/** stores 3d Mesh data */
	value: C8ThreeDMesh;
}

const ModelCheckboxTree: FunctionComponent<any> = observer(() => {
	const { threeDStore } = useStore();
	const { modelComponentsCheckboxStore } = threeDStore.canvasStore;
	
	return (
		<CheckboxTree store={modelComponentsCheckboxStore} />
	);
});

export const ThreeDModelComponents = observer(() => {
	const { rightPaneStore, threeDStore } = useStore();
	const { closeSelected } = rightPaneStore;

	const paneTitle = "3DModelComponents";
	const { meshData } = threeDStore.canvasStore;

	return (
		<StyledFlexColumn>
			<PaneHeader
				onClose={closeSelected}
				titleRes={paneTitle}
			/>
			<Box
				className={classes.containerClass}
				flexGrow={1}
				p={3}
			>
				{ meshData && <ModelCheckboxTree /> }
			</Box>
		</StyledFlexColumn>
	);
});

export default ThreeDModelComponents;